import * as React from 'react';
import { Stack, Button, ToggleButtonGroup, ToggleButton, IconButton } from '@mui/material';
import DateRangeSelector from './DateRangeSelector';
import KeySelector from '../pages/Trends/components/KeySelector';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SaveIcon from '@mui/icons-material/Save';
import { useTranslation } from 'react-i18next';

const FiltersBar = (props) => {
    const {
        selectedKeys,
        setSelectedKeys,
        onKeyClose,
        fromDate,
        toDate,
        onFromDateChange,
        onToDateChange,
        timeAggType,
        onTimeAggChange,
        onOpenFilterDrawer,
        onSave,
        showKeySelector = true,
        showSave = true,
        showTimeAggregationFilter = true,
        showFilterDrawerButton = true
    } = props;

    const { t } = useTranslation();

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ borderBottom: 2, borderColor: 'divider', p: 2 }}>
            {showKeySelector && (
                <KeySelector
                    keys={selectedKeys}
                    onChange={(newKeys) => setSelectedKeys(newKeys)}
                    onClose={onKeyClose}
                />
            )}

            <DateRangeSelector
                fromDate={fromDate}
                toDate={toDate}
                onFromDateChange={onFromDateChange}
                onToDateChange={onToDateChange}
                small={true}
            />

            {showTimeAggregationFilter && (
            <ToggleButtonGroup
                value={timeAggType}
                exclusive
                size="small"
                onChange={onTimeAggChange}
            >
                <ToggleButton value="h">{t('H')}</ToggleButton>
                <ToggleButton value="d">{t('D')}</ToggleButton>
                <ToggleButton value="m">{t('M')}</ToggleButton>
                <ToggleButton value="q">{t('Q')}</ToggleButton>
                <ToggleButton value="y">{t('Y')}</ToggleButton>
            </ToggleButtonGroup>
            )
        }

        {showFilterDrawerButton && (
            <Button variant="contained" size="small" startIcon={<FilterAltIcon />} onClick={onOpenFilterDrawer}>
                {t('Filter')}
            </Button>
        )}

            {showSave && (
                <IconButton size="medium" color="primary" onClick={onSave}>
                    <SaveIcon />
                </IconButton>
            )}
        </Stack>
    );
}

export default FiltersBar;
